import React from "react";
import CurrencyFormat from "react-currency-format";
import { useSelector } from "react-redux";


const GrandTotal = () =>{

    const state = useSelector((state)=>({
        ...state.reducer,
        ...state.orderExtrasReducer,
        ...state.priceUpdateReducer,
    }))

    return(
        (state.const_var.post_data.building!=undefined && state.const_var.BuildingPriceArrar['new_down_payment_total']!=undefined)
            ?
            <CurrencyFormat 
                value={((state.const_var.post_data.building.due_upon_installation + state.const_var.BuildingPriceArrar['new_down_payment_total'] + state.const_var.BuildingPriceArrar["custom_down_payment_total"] + state.const_var.BuildingPriceArrar['grvy_value'])).toFixed(2)}
                displayType={'text'}
                thousandSeparator={true} 
                prefix={'$'} />    
            :
            <CurrencyFormat 
                value={0}
                displayType={'text'} 
                thousandSeparator={true}
                prefix={'$'} /> 
    )
}

export default GrandTotal;